import axios from 'axios';
import React from 'react';
import { API_PATH } from './constant/constant';

/*-------------------
    画像のimport
---------------------*/
import dosyaGuide from './images/guide/dosya_guide.drawio.svg';
import inundGuide from './images/guide/inund_guide.drawio.svg';
import kaokuGuide from './images/guide/kaoku_guide.drawio.svg';
import keizokuGuide from './images/guide/keizoku_guide.drawio.svg';
import tsunamiGuide from './images/guide/tsunami_shin_guide.drawio.svg';

/**
 *世界標準時を日本時間に変更する
 *
 *
 */
export const changeJapanDate = (worldDate, format = 'YYYY年MM月DD日 hh時mm分') => {
  // 日付の変更処理(世界標準時を日本時間に変更する)
  const japanDate = new Date(worldDate);

  if (japanDate.toString() === 'Invalid Date') return '';

  const year = japanDate.getFullYear();
  const dayOfWeekStr = ['日', '月', '火', '水', '木', '金', '土'];
  const dayOfTheWeek = dayOfWeekStr[japanDate.getDay()];
  let month = japanDate.getMonth() + 1;
  let day = japanDate.getDate();
  let hour = japanDate.getHours();
  let minute = japanDate.getMinutes();
  let seconds = japanDate.getSeconds();

  if (
    year &&
    month &&
    day &&
    (hour || hour === 0) &&
    (minute || minute === 0) &&
    (seconds || seconds === 0)
  ) {
    month = `0${month}`.slice(-2);
    day = `0${day}`.slice(-2);
    hour = `0${hour}`.slice(-2);
    minute = `0${minute}`.slice(-2);
    seconds = `0${seconds}`.slice(-2);

    format = format.replace(/YYYY/g, year);
    format = format.replace(/MM/g, month);
    format = format.replace(/DD/g, day);
    format = format.replace(/d/g, dayOfTheWeek);
    format = format.replace(/hh/g, hour);
    format = format.replace(/mm/g, minute);
    format = format.replace(/ss/g, seconds);

    return format;
  }
  return '';
};

/**
 * 乱数の生成を行う。
 */
export const randomNum = () => {
  const len = 8;
  const str = 'abcdefghijklmnopqrstuvwxyz';
  const strLen = str.length;
  let result = '';

  for (let i = 0; i < len; i += 1) {
    result += str[Math.floor(Math.random() * strLen)];
  }

  return result;
};

/**
 * 地方公共団体マスタから自治体名を取得 2020/09/14 追加
 *
 */
export const getLgName = async (lgCd) => {
  const lgName = await axios
    .post(`${API_PATH}/v/getLgData`, {
      lgCd,
    })
    .then((res) => {
      const lgData = res.data;
      let tmpLgName = '';
      if (lgData.length === 0) {
        window.alert('自治体データを取得できませんでした。');
      } else {
        const { lcl_gov: lclGov = { lg_name: '' } } = lgData[0];
        const { lg_name: dbLgName = '' } = lclGov;
        tmpLgName = dbLgName;
      }
      return tmpLgName;
    })
    .catch(() => {
      window.alert('自治体データの取得に失敗しました。');
      return '';
    });

  return lgName;
};

export const getAudioSet = async (lgCd) => {
  const audioSet = await axios
    .get(`${API_PATH}/v/getMaster`, {
      params: { lgCd },
    })
    .then((res) => {
      if (res.data.length === 0) return false;

      const master = res.data[0];
      return master;
    })
    .catch(() => {
      window.alert('データの取得に失敗しました。');
      return false;
    });
  return audioSet;
};

/**
 * 住所から座標を取得する。
 * @param {Array} codeList 取得する市町村コードの配列(空だと全件)
 */
export const addressToPoint = async (address, codCheck) => {
  const addressList = await axios
    .get(codCheck, {
      params: { q: address },
    })
    .then((res) => {
      if (res.data.length === 0) {
        return [];
      }
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      return false;
    });

  return addressList;
};

/**
 * 避難所の収容率を計算する。
 */
export const culcCapacity = (capacity, limit, now, emptyCurrent = false) => {
  if (emptyCurrent === true) return { rate: '', color: '' };
  if (now === '') return { rate: '', color: '' };
  if (capacity === '') return { rate: '', color: '' };

  const rate = (now / capacity) * 100;

  let color = '';
  let level = '';
  for (let i = 0; i < limit.length; i += 1) {
    if (rate <= limit[i]) {
      if (i === 0) {
        color = '#1f8d46';
        level = '1';
      }
      if (i === 1) {
        color = '#f2e700';
        level = '2';
      }
      if (i === 2) {
        color = '#ff2800';
        level = '3';
      }
      break;
    }
  }
  if (color === '') {
    color = '#aa00aa';
    level = '4';
  }

  return { rate: rate.toFixed(1), color, level };
};

/**
 * URLからアイキャッチ画像を取得する。
 * @param {Array} urlList 取得する市町村コードの配列(空だと全件)
 */
export const urlToImg = async (urlList) => {
  const result = axios
    .post(`${API_PATH}/v/com/getImg`, { urlList })
    .then((res) => res.data)
    .catch(() => []);
  return result;
};

/**
 * 画像の存在確認
 */
export const imgExist = async (src) =>
  new Promise((resolve) => {
    const image = new Image();
    image.onload = () => resolve(true);
    image.onerror = () => resolve(false);
    image.src = src;
  });

/**
 * 文字数の改行コードを変換する。
 * @param {Array} urlList 取得する市町村コードの配列(空だと全件)
 */
export const shapedContents = (str) => {
  const splitedContents = str.split('\n');
  const shapedArray = [];
  for (let j = 0; j < splitedContents.length; j += 1) {
    if (splitedContents[j] === '') shapedArray.push(<br key={j} />);
    else shapedArray.push(<div key={j}>{splitedContents[j]}</div>);
  }

  return shapedArray;
};

/**
 * @param {Array} urlList 取得する市町村コードの配列(空だと全件)
 */
export const commonSetting = async ({ lgCd = '', enable = '', colName = '', objName = '' }) => {
  if (colName === '') return [];

  const setting = await axios
    .post(`${API_PATH}/v/com`, { lgCd, enable, kind: '1', collectionName: colName })
    .then((res) => res.data)
    .catch(() => {
      window.alert('データの取得に失敗しました。');
      return [];
    });

  if (objName === '') return setting;
  return { [objName]: setting };
};

/**
 * 表示するマーカーのデータを取得する。
 */
export const getMarker = async ({
  lgCd = '',
  pubFlag = '',
  mastaId = '',
  idName = '',
  sort = {},
  colName = '',
  objName = '',
  distance = 0,
  currentPoint = [],
}) => {
  if (colName === '') return [];

  const marker = await axios
    .post(`${API_PATH}/v/getPubMarker`, {
      lgCd,
      pubFlag,
      mastaId,
      distance,
      currentPoint,
      idName,
      sort,
      kind: '1',
      collectionName: colName,
    })
    .then((res) => res.data)
    .catch(() => {
      window.alert('データの取得に失敗しました。');
      return [];
    });

  if (objName === '') return marker;
  return { [objName]: marker };
};

/**
 * 暗号化されたURLから市町村コードを取得する。
 */
export const getLgCd = async (lgCrypt = '') => {
  if (lgCrypt === '') return '';

  // 地図の設定を取得
  const urlSetting = await axios
    .post(`${API_PATH}/v/com/getUrl`, { lgCrypt })
    .then((res) => res.data)
    .catch(() => []);

  if (urlSetting.length === 0) return { lgCd: '', permission: 0 };
  const { lcl_gov: lclGov = '', permission = 7 } = urlSetting[0] || '';
  const { lg_cd: lgCd = '' } = lclGov;
  return { lgCd, permission };
};

/**
 * エラーページに画面遷移させる。
 */
export const moveErrorPage = async (props, kind) => {
  const { history } = props;
  history.push({
    pathname: `/ErrorPage`,
    search: `kind=${kind}`,
  });
};

/**
 * promise後の配列をオブジェクトに変更する。
 */
export const changePromiseRes = (results) => {
  const resultList = {};
  // 配列になっているため、オブジェクトに変更する。
  for (let i = 0; i < results.length; i += 1) {
    const keyName = Object.keys(results[i]);
    for (let j = 0; j < keyName.length; j += 1) {
      resultList[keyName[j]] = results[i][keyName[j]];
    }
  }
  return resultList;
};

/**
 * 使用する凡例をIDを元に画像要素で返す。
 */
export const useGuide = (strValue) => {
  const tmpValue = parseInt(strValue, 10);
  if (tmpValue === 1) {
    return <img key={randomNum()} src={inundGuide} alt="凡例" className="legend-img" />;
  }
  if (tmpValue === 2) {
    return <img key={randomNum()} src={inundGuide} alt="凡例" className="legend-img" />;
  }
  if (tmpValue === 4) {
    return <img key={randomNum()} src={keizokuGuide} alt="凡例" className="legend-img" />;
  }
  if (tmpValue === 8) {
    return <img key={randomNum()} src={kaokuGuide} alt="凡例" className="legend-img" />;
  }
  if (tmpValue === 16) {
    return <img key={randomNum()} src={kaokuGuide} alt="凡例" className="legend-img" />;
  }
  if (tmpValue === 32) {
    return <img key={randomNum()} src={dosyaGuide} alt="凡例" className="legend-img" />;
  }
  if (tmpValue === 64) {
    return <img key={randomNum()} src={dosyaGuide} alt="凡例" className="legend-img" />;
  }
  if (tmpValue === 128) {
    return <img key={randomNum()} src={dosyaGuide} alt="凡例" className="legend-img" />;
  }
  if (tmpValue === 256) {
    return <img key={randomNum()} src={tsunamiGuide} alt="凡例" className="legend-img" />;
  }
  return [];
};

/**
 * 背景色に応じた文字色(白or黒)を返す。
 * colorはHEXなら#121212の形式、RGBなら124,12,54の形式
 */
export const backColorCheck = (color = '', hex = false) => {
  const lum = 128; // 輝度信号 Y の白黒分岐点 (128 がジャスト真ん中)

  const checkColor = [];
  // 16進数の場合はRGBにする。
  if (hex === true) {
    // #を除去して6桁の16進数に変換
    const hexValue = color.replace('#', '');
    if (hexValue.length !== 6) {
      return ''; // 無効なカラーコードの場合
    }

    // 16進数をRGB値に変換
    checkColor.push(parseInt(hexValue.substring(0, 2), 16));
    checkColor.push(parseInt(hexValue.substring(2, 4), 16));
    checkColor.push(parseInt(hexValue.substring(4, 6), 16));
  } else {
    // RGBの場合はsplitする。
    const [r, g, b] = color.split(',');
    checkColor.push(r);
    checkColor.push(g);
    checkColor.push(b);
  }

  const [r, g, b] = checkColor;

  // RGB から YUV の輝度信号に変換
  const yuv = 0.299 * r + 0.587 * g + 0.114 * b;

  return yuv >= lum ? '#000000' : '#ffffff';
};

/**
 * 16進数の色コードをRGB形式に変換する。
 */
export const hexToRgb = (hexColor, opacity) => {
  // #を除去して6桁の16進数に変換
  const hexValue = hexColor.replace('#', '');
  if (hexValue.length !== 6) {
    return null; // 無効なカラーコードの場合はnullを返す
  }

  // 16進数をRGB値に変換
  const r = parseInt(hexValue.substring(0, 2), 16);
  const g = parseInt(hexValue.substring(2, 4), 16);
  const b = parseInt(hexValue.substring(4, 6), 16);

  // RGB形式の文字列を返す
  return `${r},${g},${b},${opacity}`;
};

/**
 * RGBの色コードを16進数に変換する。
 */
export const rgbToHex = (rgb) => {
  // RGB形式の文字列から数値を取得
  const splitRgb = rgb.split(',');

  let hexColor = '#';
  for (let i = 0; i < 3; i += 1) {
    const tmpHex = `${parseInt(splitRgb[i], 10).toString(16)}`.padStart(2, '0');
    hexColor = `${hexColor}${tmpHex}`;
  }

  return hexColor;
};

/**
 * 投稿フォームで表示するバッチの内容を返す。
 */
export const postStatus = (postKind = '0', htmlGet = true) => {
  const num = parseInt(postKind, 10);
  const colorSet = ['#616161', '#1e88e5', '#ef6c00', '#388e3c'];
  const nameSet = ['未確認', '対応中', '確認中', '完了'];

  if (num === 4 && htmlGet) {
    return '';
  }
  if (htmlGet) {
    return `<span class="status-badge" style="background:${colorSet[num]}">${nameSet[num]}</span>`;
  }

  if (num === 4) {
    return {
      noDisp: (
        <span className="pb-badge" style={{ color: '#000', border: '#000 solid 1px' }}>
          表示なし
        </span>
      ),
    };
  }
  return { color: colorSet[num], name: nameSet[num] };
};

/**
 * 入力項目作成用
 * @param {string} value 入力項目のstate名
 * @param {string} tmpStr stateの現在の値
 * @param {string} kind 入力項目の種別
 * @param {Array} setMethod 単一setState用メソッド
 */
export const inputNumber = (value, tmpStr, min, max, setMethod) => {
  let body = '';
  // 通常のinput型
  body = (
    <input
      type="number"
      min={min}
      max={max}
      value={tmpStr}
      onChange={(e) => {
        // onBlur={(e) => {
        setMethod(value, e.target.value);
      }}
    />
  );
  return body;
};

/**
 * コピー用
 */
export const Test = () => {};
